import { render, staticRenderFns } from "./ParticipantDocumentActionsComponent.vue?vue&type=template&id=abddd07a&"
import script from "./ParticipantDocumentActionsComponent.vue?vue&type=script&lang=js&"
export * from "./ParticipantDocumentActionsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports